import React from "react";
import { Chip, Tooltip } from "@sscs/ui";
import styles from "./cweChip.module.scss";
const Info = ({ info }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.info },
            React.createElement("b", null, info.name)),
        React.createElement("div", null, info.description)));
};
const CweChip = ({ cwe }) => {
    return cwe.name && cwe.description ? (React.createElement(Tooltip, { trigger: "graphic", title: React.createElement(Info, { info: cwe }) },
        React.createElement(Chip, { label: cwe.cwe_id }))) : (React.createElement(Chip, { label: cwe.cwe_id }));
};
export default CweChip;
//# sourceMappingURL=CweChip.js.map